/**
 * @function v3sGraphic
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * The Graphic Element
 */
angular.module('v3sWbtPlayerApp').directive('v3sGraphic', ["v3sContentMediaPath", "v3sContentConfig", function (v3sContentMediaPath, v3sContentConfig) {
    return {
        restrict: 'E',
        require: '^v3sDocument',
        scope: {
            id: '@',
            v3sType: '@',
            v3sAlign: '@',
            v3sFloat: '@',
            v3sFile: '@'
        },
        //template: '<img></img>',
        link: function (scope, element, attrs, docCtrl) {
            if (!!scope.id) {
                docCtrl.addElement(element);
            }

            /**
             * Grafiken sind nur absolute positioniert, wenn sie kein Elternelement haben (popup etc)
             */

            var thumbnail = element.find("v3s-thumbnail") || false;

            var img = angular.element('<img></img>');
            element.append(img);
            img.attr({
                "src": v3sContentMediaPath + attrs.v3sFile
            });

            /**
             * Wenn der Thumbnail nur mobile angezeigt werden soll
             * muss die Grafik nur auf dem Desktop angezeigt werden.
             * Ansonsten brauchen beides mal den Thumbnail
             */
            var thumbnailOnDesktop = (thumbnail.attr('v3s-desktop') == 'true');
            var thumbnailOnMobile = (thumbnail.attr('v3s-mobile') == 'true');
            if ((thumbnailOnDesktop || thumbnailOnMobile) && thumbnail.length > 0 && (thumbnail.attr("v3s-width") > 0 && thumbnail.attr("v3s-height") > 0)) {
                if (thumbnailOnDesktop && thumbnailOnMobile) {
                    img.css("display", "none");
                } else if (thumbnailOnDesktop && !thumbnailOnMobile) {
                    if (v3sContentConfig.responsive) {
                        img.addClass('only-mobile');
                    } else {
                        img.css("display", "none");
                    }
                } else if (!thumbnailOnDesktop && thumbnailOnMobile) {
                    img.addClass('only-desktop');
                }
            }




            /**
             * Grafiken im Popup
             * Es wird margin benutzt, da text-align für Grafiken nicht mehr funktioniert in den richtigen Browsern
             */
            var isFloating = (scope.v3sFloat === 'true');
            var isAligned = !!scope.v3sAlign;
            if (isAligned) {
                if (isFloating) {
                    element.addClass('popup-image-float-' + scope.v3sAlign);
                    element.addClass('pull-' + scope.v3sAlign);
                } else {
                    (scope.v3sAlign == 'left') ? img.addClass('popup-image-align-left') : (scope.v3sAlign == 'right') ? img.addClass('popup-image-align-right') : img.addClass('popup-image-align-center');
                }
            }
        }
    };
}]);
